import {
  AccountTree,
  Add,
  Article,
  CalculateOutlined,
  CurrencyExchange,
  Done,
  ForumOutlined,
  HomeOutlined,
  MenuOutlined,
  PeopleAlt,
  Reddit,
  StarsOutlined,
  ThumbsUpDownOutlined,
  // Twitter,
} from "@mui/icons-material";
import {
  AppBar,
  Box,
  ButtonBase,
  Divider,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from "@mui/material";
import { useMemo, useState } from "react";
import PowerIndex from "../../components/analytics/PowerIndex";
import QuickViewCards from "../../components/analytics/quickViewCards";
import ChallengeFundsInFund from "../../components/charts/ChallengeFundsInFund";
import CompletedCountsLineChart from "../../components/charts/CompletedCountsLineChart";
import ForumWordCloud from "../../components/charts/forum/ForumWordCloud";
// import CompletionTimeROI from "../../components/charts/CompletionTimeROI";
import FundAvailability from "../../components/charts/FundAvailability";
import MaxMinAvgFundsChart from "../../components/charts/MaxMinAvgFunds";
import ProjectStatus from "../../components/charts/ProjectStatus";
import PropertiesBubblePlot from "../../components/charts/PropertiesBubblePlot";
import PropertiesScatterPlot from "../../components/charts/PropertiesScatterPlot";
import ProposalCountAmountSum from "../../components/charts/ProposalCountAmountSumChart";
import ProposerBubblePlot from "../../components/charts/ProposerBubblePlot";
import ProposerCorrelationMatrix from "../../components/charts/ProposerCorrelationMatrix";
import ProposerScatterPlot from "../../components/charts/ProposerScatterPlot";
import TotalBudgetPerFund from "../../components/charts/TotalBudgetPerFund";
// import TwitterDatePropertyScatter from "../../components/charts/twitter/TwitterDatePropertyScatter";
// import TwitterDistribution from "../../components/charts/twitter/TwitterDistribution";
// import TwitterProperty from "../../components/charts/twitter/TwitterProperty";
// import TwitterPropertyBar from "../../components/charts/twitter/TwitterPropertyBar";
// import TwitterSentiments from "../../components/charts/twitter/TwitterSentiments";
// import TwitterWordCloud from "../../components/charts/twitter/TwitterWordCloud";
import VariationOfFunds from "../../components/charts/VariationOfFunds";
import CustomAccordion from "../../components/common/customAccordion";
import Footer from "../../components/common/Footer";
import Navbar from "../../components/common/NavBar";
import { desc } from "../../lib/chartDescription";
import styles from "../../styles/analytics/analyticsPanel.module.css";
import RedditWordCloud from "../../components/charts/reddit/RedditWordCloud";
import ForumDatePropertyScatter from "../../components/charts/forum/ForumDatePropertyScatter";
import RedditDistribution from "../../components/charts/reddit/RedditDistribution";
// import RedditSentiments from "../../components/charts/reddit/RedditSentiments";
import RedditProperty from "../../components/charts/reddit/RedditProperty";
import RedditPropertyBar from "../../components/charts/reddit/RedditPropertyBar";
import RedditDatePropertyScatter from "../../components/charts/reddit/RedditDatePropertyScatter";
import RedditSentiments from "../../components/charts/reddit/RedditSentiments";

const drawerWidth = 180;

export default function AnalyticsPanel() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const initialState = {
    all: false,
    fund: false,
    proposal: false,
    challenges: false,
    project: false,
    proposer: false,
    rating: false,
    votes: false,
    twitter: false,
    reddit: false,
    forum: false,
    power: false,
  };
  const [showCharts, setShowCharts] = useState(initialState);

  const handleRemoveCharts = (name: string) => {
    setShowCharts({
      ...showCharts,
      [name]: false,
    });
  };

  const handleShowCharts = (name: string) => {
    setShowCharts({
      ...showCharts,
      [name]: !showCharts[name as "all"] as boolean,
    });
  };

  const handleMovetoHome = () => {
    setShowCharts(initialState);
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div className={styles.drawerContainer}>
      {/* <Toolbar /> */}
      <Divider />
      <List>
        <ListItem disablePadding onClick={() => handleMovetoHome()}>
          <ListItemButton>
            <ListItemIcon sx={{ minWidth: "45px" }}>
              <HomeOutlined />
            </ListItemIcon>
            <ListItemText primary={"Home"} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={() => handleShowCharts("proposal")}>
          <ButtonBase>
            <ListItemButton>
              <ListItemIcon sx={{ minWidth: "45px" }}>
                <AccountTree />
              </ListItemIcon>
              <ListItemText
                primary={
                  <div className="spaceBetween" style={{ gap: "10px" }}>
                    Proposal{showCharts.proposal ? <Done /> : <Add />}
                  </div>
                }
              />
            </ListItemButton>
          </ButtonBase>
        </ListItem>
        <ListItem disablePadding onClick={() => handleShowCharts("fund")}>
          <ListItemButton>
            <ListItemIcon sx={{ minWidth: "45px" }}>
              <CurrencyExchange />
            </ListItemIcon>
            <ListItemText
              primary={
                <div className="spaceBetween" style={{ gap: "10px" }}>
                  Fund{showCharts.fund ? <Done /> : <Add />}
                </div>
              }
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={() => handleShowCharts("project")}>
          <ListItemButton>
            <ListItemIcon sx={{ minWidth: "45px" }}>
              <Article />
            </ListItemIcon>
            <ListItemText
              primary={
                <div className="spaceBetween" style={{ gap: "10px" }}>
                  Project{showCharts.project ? <Done /> : <Add />}
                </div>
              }
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={() => handleShowCharts("proposer")}>
          <ListItemButton>
            <ListItemIcon sx={{ minWidth: "45px" }}>
              <PeopleAlt />
            </ListItemIcon>
            <ListItemText
              primary={
                <div className="spaceBetween" style={{ gap: "10px" }}>
                  Proposer{showCharts.proposer ? <Done /> : <Add />}
                </div>
              }
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={() => handleShowCharts("rating")}>
          <ListItemButton>
            <ListItemIcon sx={{ minWidth: "45px" }}>
              <StarsOutlined />
            </ListItemIcon>
            <ListItemText
              primary={
                <div className="spaceBetween" style={{ gap: "10px" }}>
                  Rating{showCharts.rating ? <Done /> : <Add />}
                </div>
              }
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={() => handleShowCharts("votes")}>
          <ListItemButton>
            <ListItemIcon sx={{ minWidth: "45px" }}>
              <ThumbsUpDownOutlined />
            </ListItemIcon>
            <ListItemText
              primary={
                <div className="spaceBetween" style={{ gap: "10px" }}>
                  Votes{showCharts.votes ? <Done /> : <Add />}
                </div>
              }
            />
          </ListItemButton>
        </ListItem>
        {/* <ListItem disablePadding onClick={() => handleShowCharts("twitter")}>
          <ListItemButton>
            <ListItemIcon sx={{ minWidth: "45px" }}>
              <Twitter />
            </ListItemIcon>
            <ListItemText
              primary={
                <div className="spaceBetween" style={{ gap: "10px" }}>
                  Twitter{showCharts.twitter ? <Done /> : <Add />}
                </div>
              }
            />
          </ListItemButton>
        </ListItem> */}
        {/* <ListItem disablePadding onClick={() => handleShowCharts("reddit")}>
          <ListItemButton>
            <ListItemIcon sx={{ minWidth: "45px" }}>
              <Reddit />
            </ListItemIcon>
            <ListItemText
              primary={
                <div className="spaceBetween" style={{ gap: "10px" }}>
                  Reddit{showCharts.reddit ? <Done /> : <Add />}
                </div>
              }
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={() => handleShowCharts("forum")}>
          <ListItemButton>
            <ListItemIcon sx={{ minWidth: "45px" }}>
              <ForumOutlined />
            </ListItemIcon>
            <ListItemText
              primary={
                <div className="spaceBetween" style={{ gap: "10px" }}>
                  Forum{showCharts.forum ? <Done /> : <Add />}
                </div>
              }
            />
          </ListItemButton>
        </ListItem> */}
        <ListItem disablePadding onClick={() => handleShowCharts("power")}>
          <ListItemButton>
            <ListItemIcon sx={{ minWidth: "45px" }}>
              <CalculateOutlined />
            </ListItemIcon>
            <ListItemText
              primary={
                <div className="spaceBetween" style={{ gap: "10px" }}>
                  Banzhaf PI{showCharts.power ? <Done /> : <Add />}
                </div>
              }
            />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  const quickView = useMemo(() => {
    return (
      <div className={styles.grid_container_1}>
        <div className={styles.gridItem1}>
          <FundAvailability />
        </div>
        <QuickViewCards />

        <div className={styles.item3}>
          <ProposalCountAmountSum
            xlabel="Fund"
            ylabel="Proposal Count"
            InitialStatus="All"
            shouldShowDropDown={false}
          />
        </div>
        <div className={styles.item4}>
          <VariationOfFunds
            xlabel="Challenge"
            ylabel="No. of Ratings"
            single_fund={true}
            property_type="Rating"
          />
        </div>
        <div className={styles.item5}>
          <ProposerCorrelationMatrix shouldShowOption={false} />
        </div>
        <div className={styles.item6}>
          <TotalBudgetPerFund
            chartTitle="Total Budget in Each Fund"
            xLabel="Fund"
            yLabel="Total Budget ($)"
            popUpHandler={(title: string) => popup(title)}
          />
        </div>
        <div className={styles.item10}>
          <ChallengeFundsInFund showSelect="flex" />
        </div>
        <div className={styles.item7}>
          {/* <RedditWordCloud /> */}
          <MaxMinAvgFundsChart
            xlabel="Fund"
            ylabel="Amount($)"
            single_fund={false}
            property_type="Amount"
            chartType="bar"
          />
        </div>
        {/* <div className={styles.item8}>
          <PowerIndex />
        </div> */}
      </div>
    );
  }, []);

  const proposalView = useMemo(() => {
    return (
      <>
        {showCharts.proposal && (
          <CustomAccordion
            title="Proposal"
            handleClose={() => handleRemoveCharts("proposal")}
          >
            <Grid container spacing={4} justifyContent="center">
              <Grid
                item
                xs={12}
                md={12}
                sm={12}
                lg={6}
                xl={4}
                className={styles.chartItem}
              >
                <ProposalCountAmountSum xlabel="Fund" ylabel="Proposal Count" />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sm={12}
                lg={6}
                xl={4}
                className={styles.chartItem}
              >
                <MaxMinAvgFundsChart
                  xlabel="Fund"
                  ylabel="Proposal Count"
                  single_fund={false}
                  property_type="Proposal"
                  chartType="bar"
                  typeArray={["Count"]}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sm={12}
                lg={6}
                xl={4}
                className={styles.chartItem}
              >
                <MaxMinAvgFundsChart
                  xlabel="Fund"
                  ylabel="Proposal Count"
                  single_fund={true}
                  property_type="Proposal"
                  chartType="bar"
                  typeArray={["Count"]}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <PropertiesScatterPlot
                  xLabel="Fund"
                  yLabel="Count"
                  numberOfCategories={3}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <PropertiesBubblePlot />
              </Grid>
            </Grid>
          </CustomAccordion>
        )}
      </>
    );
    //eslint-disable-next-line
  }, [showCharts.proposal]);

  const fundView = useMemo(() => {
    return (
      <>
        {showCharts.fund && (
          <CustomAccordion
            title="Fund"
            handleClose={() => handleRemoveCharts("fund")}
          >
            <Grid container spacing={4} justifyContent="center">
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <MaxMinAvgFundsChart
                  xlabel="Fund"
                  ylabel="Amount($)"
                  single_fund={false}
                  property_type="Amount"
                  chartType="bar"
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <MaxMinAvgFundsChart
                  xlabel="Fund"
                  ylabel="Amount($)"
                  single_fund={true}
                  property_type="Amount"
                  chartType="bar"
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                sm={12}
                lg={6}
                xl={4}
                className={styles.chartItem}
              >
                <TotalBudgetPerFund
                  chartTitle="Total Budget in Each Fund"
                  xLabel="Fund"
                  yLabel="Total ($)"
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sm={12}
                lg={6}
                xl={4}
                className={styles.chartItem}
              >
                <VariationOfFunds
                  xlabel="Fund"
                  ylabel="Amount ($)"
                  single_fund={false}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sm={12}
                lg={6}
                xl={4}
                className={styles.chartItem}
              >
                <VariationOfFunds
                  xlabel="Challenge"
                  ylabel="Amount ($)"
                  single_fund={true}
                />
              </Grid>

              {/* <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <CompletionTimeROI popped={false} />
              </Grid> */}
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <ChallengeFundsInFund showSelect="flex" />
              </Grid>
            </Grid>
          </CustomAccordion>
        )}
      </>
    );
    //eslint-disable-next-line
  }, [showCharts.fund]);

  const projectView = useMemo(() => {
    return (
      <>
        {showCharts.project && (
          <CustomAccordion
            title="Project"
            handleClose={() => handleRemoveCharts("project")}
          >
            <Grid container spacing={4} justifyContent="center">
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <ProjectStatus
                  xlabel="Fund"
                  ylabel="Count"
                  single_fund={false}
                  fund_id="All"
                  desc={desc.project.projectStatusAll}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <ProjectStatus
                  xlabel="Fund"
                  ylabel="Count"
                  single_fund={true}
                  fund_id={4}
                  desc={desc.project.projectStatusFund}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <CompletedCountsLineChart />
              </Grid>
            </Grid>
          </CustomAccordion>
        )}
      </>
    );
    //eslint-disable-next-line
  }, [showCharts.project]);

  const proposerView = useMemo(() => {
    return (
      <>
        {showCharts.proposer && (
          <CustomAccordion
            title="Proposer"
            handleClose={() => handleRemoveCharts("proposer")}
          >
            <Grid container spacing={4} justifyContent="center">
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <ProposerCorrelationMatrix />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <ProposerBubblePlot />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <ProposerScatterPlot />
              </Grid>
            </Grid>
          </CustomAccordion>
        )}
      </>
    );
    //eslint-disable-next-line
  }, [showCharts.proposer]);

  const ratingView = useMemo(() => {
    return (
      <>
        {showCharts.rating && (
          <CustomAccordion
            title="Rating"
            handleClose={() => handleRemoveCharts("rating")}
          >
            <Grid container spacing={4} justifyContent="center">
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <MaxMinAvgFundsChart
                  xlabel="Fund"
                  ylabel="Rating"
                  single_fund={false}
                  property_type="Rating"
                  chartType="bar"
                  typeArray={["Avg", "Max", "Min"]}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <VariationOfFunds
                  xlabel="Fund"
                  ylabel="No. of Ratings"
                  single_fund={false}
                  property_type="Rating"
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <MaxMinAvgFundsChart
                  xlabel="Fund"
                  ylabel="Rating"
                  single_fund={true}
                  property_type="Rating"
                  chartType="bar"
                  typeArray={["Avg", "Max", "Min"]}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <VariationOfFunds
                  xlabel="Challenge"
                  ylabel="No. of Ratings"
                  single_fund={true}
                  property_type="Rating"
                />
              </Grid>
            </Grid>
          </CustomAccordion>
        )}
      </>
    );
    //eslint-disable-next-line
  }, [showCharts.rating]);

  const votesView = useMemo(() => {
    return (
      <>
        {showCharts.votes && (
          <CustomAccordion
            title=" Votes"
            handleClose={() => handleRemoveCharts("rating")}
          >
            <Grid container spacing={4} justifyContent="center">
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <MaxMinAvgFundsChart
                  xlabel="Fund"
                  ylabel="Rating"
                  single_fund={false}
                  property_type="Votes"
                  chartType="bar"
                  typeArray={["Avg", "Max", "Min", "Sum"]}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <MaxMinAvgFundsChart
                  xlabel="Fund"
                  ylabel="Rating"
                  single_fund={true}
                  property_type="Votes"
                  chartType="bar"
                  typeArray={["Avg", "Max", "Min", "Sum"]}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <VariationOfFunds
                  xlabel="Fund"
                  ylabel="No. of Votes"
                  single_fund={false}
                  property_type="Votes"
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <VariationOfFunds
                  xlabel="Challenge"
                  ylabel="No.of Votes"
                  single_fund={true}
                  property_type="Votes"
                />
              </Grid>
            </Grid>
          </CustomAccordion>
        )}
      </>
    );
    //eslint-disable-next-line
  }, [showCharts.votes]);

  // const twitterView = useMemo(() => {
  //   return (
  //     <>
  //       {showCharts.twitter && (
  //         <CustomAccordion
  //           title="Twitter"
  //           handleClose={() => handleRemoveCharts("twitter")}
  //         >
  //           <Grid container spacing={4} justifyContent="center">
  //             <Grid
  //               item
  //               xs={12}
  //               md={12}
  //               lg={6}
  //               xl={4}
  //               sm={12}
  //               className={styles.chartItem}
  //             >
  //               <TwitterProperty type="timeSeries" />
  //             </Grid>

  //             <Grid
  //               item
  //               xs={12}
  //               md={12}
  //               lg={6}
  //               xl={4}
  //               sm={12}
  //               className={styles.chartItem}
  //             >
  //               <TwitterWordCloud />
  //             </Grid>

  //             <Grid
  //               item
  //               xs={12}
  //               md={12}
  //               lg={6}
  //               xl={4}
  //               sm={12}
  //               className={styles.chartItem}
  //             >
  //               <TwitterDistribution />
  //             </Grid>
  //             <Grid
  //               item
  //               xs={12}
  //               md={12}
  //               lg={6}
  //               xl={4}
  //               sm={12}
  //               className={styles.chartItem}
  //             >
  //               <TwitterPropertyBar />
  //             </Grid>
  //             <Grid
  //               item
  //               xs={12}
  //               md={12}
  //               lg={6}
  //               xl={4}
  //               sm={12}
  //               className={styles.chartItem}
  //             >
  //               <TwitterSentiments />
  //             </Grid>
  //             <Grid
  //               item
  //               xs={12}
  //               md={12}
  //               lg={6}
  //               xl={4}
  //               sm={12}
  //               className={styles.chartItem}
  //             >
  //               <TwitterProperty />
  //             </Grid>

  //             <Grid
  //               item
  //               xs={12}
  //               md={12}
  //               lg={6}
  //               xl={4}
  //               sm={12}
  //               className={styles.chartItem}
  //             >
  //               <TwitterPropertyBar type="ByMonth" />
  //             </Grid>
  //             <Grid
  //               item
  //               xs={12}
  //               md={12}
  //               lg={6}
  //               xl={4}
  //               sm={12}
  //               className={styles.chartItem}
  //             >
  //               <TwitterDatePropertyScatter />
  //             </Grid>
  //           </Grid>
  //         </CustomAccordion>
  //       )}
  //     </>
  //   );
  //   //eslint-disable-next-line
  // }, [showCharts.twitter]);

  const redditView = useMemo(() => {
    return (
      <>
        {showCharts.reddit && (
          <CustomAccordion
            title="Reddit"
            handleClose={() => handleRemoveCharts("reddit")}
          >
            <Grid container spacing={4} justifyContent="center">
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <RedditProperty type="timeSeries" />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <RedditWordCloud />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <RedditDistribution />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <RedditSentiments />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <RedditPropertyBar />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <RedditPropertyBar type="ByMonth" />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <RedditProperty />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <RedditDatePropertyScatter />
              </Grid>
            </Grid>
          </CustomAccordion>
        )}
      </>
    );
    //eslint-disable-next-line
  }, [showCharts.reddit]);

  const forumView = useMemo(() => {
    return (
      <>
        {showCharts.forum && (
          <CustomAccordion
            title="Forum"
            handleClose={() => handleRemoveCharts("forum")}
          >
            <Grid container spacing={4} justifyContent="center">
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <ForumWordCloud />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={6}
                xl={4}
                sm={12}
                className={styles.chartItem}
              >
                <ForumDatePropertyScatter />
              </Grid>
            </Grid>
          </CustomAccordion>
        )}
      </>
    );
    //eslint-disable-next-line
  }, [showCharts.forum]);

  const powerIndexView = useMemo(() => {
    return (
      <>
        {showCharts.power && (
          <CustomAccordion
            title="Banzhaf Power Index"
            handleClose={() => handleRemoveCharts("power")}
          >
            <Grid container spacing={4} justifyContent="center">
              <PowerIndex />
            </Grid>
          </CustomAccordion>
        )}
      </>
    );
    //eslint-disable-next-line
  }, [showCharts.power]);

  const popup = (name: string) => {};
  return (
    <>
      <Box
        sx={{ maxWidth: "100%", overflowX: "hidden" }}
        className={styles.pageContainer}
      >
        <Navbar />

        <Box sx={{ display: "flex", flexDirection: "row" }}>
          {/* <CssBaseline /> */}
          <Box
            component="nav"
            sx={{
              width: { md: drawerWidth },
              flexShrink: { md: 0 },
              marginTop: "60px",
            }}
          >
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Drawer
              // container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: "block", sm: "block", md: "none" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  marginTop: "60px",
                },
              }}
            >
              {drawer}
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: "none", md: "block" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  marginTop: "65px",
                },
              }}
              open
            >
              {drawer}
            </Drawer>
          </Box>
          <div className={styles.backgroundColor}></div>
          <Box className={styles.mainSectionContainer}>
            <AppBar
              position="fixed"
              sx={{
                display: { md: "none" },
                width: { md: "100%" },
                ml: { md: `${drawerWidth}px` },
                marginTop: "60px",
                background: "transparent",
              }}
              elevation={0}
            >
              <Toolbar>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{
                    mr: 2,
                    display: { md: "none" },
                    backgroundColor: "#fafafa",
                  }}
                >
                  <MenuOutlined color="primary" />
                </IconButton>
              </Toolbar>
            </AppBar>
            <Toolbar />
            {quickView}
            {proposalView}
            {fundView}
            {projectView}
            {proposerView}
            {ratingView}
            {votesView}
            {/* {twitterView} */}
            {redditView}
            {forumView}
            {powerIndexView}
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
}
